/**
 * all ado search eapi（ShoppingShopping）
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoundtripFppItemAirBoundsDataTypeFareInfos } from './roundtripFppItemAirBoundsDataTypeFareInfos';
import { RoundtripFppItemAirBoundsDataTypeAirBound } from './roundtripFppItemAirBoundsDataTypeAirBound';

/**
 * key：Fare Family Code<br>ASWDB(マスタ)に存在するFare Family Codeのみをkeyとする。<br> value：Air Bound情報
 */
export interface RoundtripFppItemAirBoundsDataType {
  isCanChooseAfterFilter?: boolean;
  /**
   * Air Bound ID
   */
  airBoundId: string;
  /**
   * プライオリティコード(10000-hierarchyの値)
   */
  priorityCode: string;
  /**
   * 残席状況<br>当該Air Boundのセグメントのうち、最も残席数が少ないセグメントの情報<br>※DxAPIの残席数をもとに、残席数が1以上の場合、設定ファイルに定義した閾値に沿って下記のいずれかに該当するかを判定する。<br>   1. enough：十分空席あり<br>※設定ファイルに空席あり表示上限値が定義されている場合に残席数が空席あり表示上限値を超えている、または設定ファイルに空席あり表示上限値が定義されていない場合に残席数が設定ファイルに定義した実数表示上限値を超えている場合は十分空席ありとする。   1. available：空席あり<br>※設定ファイルに空席あり表示上限値が定義されている場合に残席数が空席あり表示上限値以下、かつ残席数が設定ファイルに定義した実数表示上限値を超えている場合は空席ありとする。   1. few：残席わずか<br>※残席数が設定ファイルに定義した実数表示上限値以下である場合は残席わずかとする。   1. soldOut：売り切れ<br>※以下いずれかを満たす場合は売り切れとする。<br>     1. 当該Air Boundの残席数が搭乗者数を下回っている、かつ空席待ちではない。     1. 当該Air Boundが空席待ち、かつ出発日時が設定ファイルに定義された最終空席待ち期限を過ぎている。     1. 当該Air Boundが空席待ち、かつ第1セグメントの運航キャリアがNHグループ運航便および設定ファイルに定義された国内提携航空キャリアではない。
   */
  quotaType: RoundtripFppItemAirBoundsDataType.QuotaTypeEnum;
  /**
   * 残席数<br>当該Air Boundのセグメントのうち、最も残席数が少ないセグメントの情報※quotaTypeが「few」の場合に返却する。
   */
  quota: number;
  /**
   * 無料預け入れ手荷物個数<br>当該Air Boundに含まれるセグメントに対する最小の値を返却する。
   */
  minFreeCheckedBaggageQuantity: number;
  /**
   * 無料機内持ち込み手荷物個数<br>当該Air Boundに含まれるセグメントに対する最小の値を返却する。
   */
  minFreeCarryOnBaggageQuantity: number;
  airBound?: RoundtripFppItemAirBoundsDataTypeAirBound;
  fareInfos: RoundtripFppItemAirBoundsDataTypeFareInfos;
  /**
   * 当該Air Boundが利用不可かどうか<br>不可理由が存在する場合trueを返却する。
   */
  isUnavailable: boolean;
  /**
   * 不可理由<br>利用不可の場合にのみ返却する。※下記の順に判定を行い、最初に該当した項目を返却する。<br> 1. passedLastBookingDate：第1バウンドの第1セグメントが最終発券期限を過ぎている。<br>最終発券期間を過ぎているかどうかは、往路または片道検索の場合に当該Air Boundの第1セグメントが下記いずれかを満たしているかどうかで判定する。   1. 運航キャリアがPeach運航便の場合、出発時刻まで3時間未満である。   1. 空席待ち、かつ出発日時が設定ファイルに定義された最終空席待ち期限を過ぎている、または残席無である。   1. 上記のいずれにも該当しない場合、出発時刻まで20分未満である。 1. incorrectChildFareCalculation：小児運賃計算不正Fare Familyを含んでいる。<br>下記の全てに一致する場合に該当する。   1. 呼び出し元より小児人数が1人以上である。   1. 当該Air Boundに含まれるFare Familyコードが、設定ファイルに定義された小児運賃計算不正Fare Familyコードと一致している。 1. unavailableJuniorPilot : 呼び出し元より小児人数が1人、かつ大人が別予約で同行しない場合、下記いずれかを満たす場合に該当する。   1. 当該Air BoundにPeach運航便を含む。   1. 同暦日での乗り継ぎではない。ただし、羽田空港での乗り継ぎの場合、翌日の設定ファイルで定義した出発時間までを同暦日とする。   1. 同空港での乗り継ぎではない。<br>※マルチエアポートで異なる空港である場合も該当する。 1. soldOut：以下いずれかを満たす場合に該当する。   1. 当該Air Boundの残席数が搭乗者数を下回っている、かつ空席待ちではない。   1. 当該Air Boundが空席待ち、かつ出発日時が設定ファイルに定義された最終空席待ち期限を過ぎている。   1. 当該Air Boundが空席待ち、かつ第1セグメントの運航キャリアがNHグループ運航便および設定ファイルに定義された国内提携航空キャリアではない。
   */
  unavailableReason: RoundtripFppItemAirBoundsDataType.UnavailableReasonEnum;
  /**
   * ASWDB(マスタ)のキャビンクラス
   */
  cabin: RoundtripFppItemAirBoundsDataType.CabinEnum;
  /**
   * 変更条件タイプ<br>当該Fare Familyのプライオリティコードを基に取得した、ASWDB(マスタ)の変更可否区分を返却する。(unavailable：予約変更不可 withPenalty：予約変更可能（手数料あり）free：予約変更可能（手数料なし）)
   */
  changeConditionsType: RoundtripFppItemAirBoundsDataType.ChangeConditionsTypeEnum;
  /**
   * 払戻条件タイプ<br>プライオリティコードを基に取得した、ASWDB(マスタ)の払戻可否区分を返却する。(unavailable：払戻不可 chargeable：払戻可能（手数料あり）free：払戻可能（手数料なし））
   */
  refundConditionsType: RoundtripFppItemAirBoundsDataType.RefundConditionsTypeEnum;
  /**
   * 空席待ちかどうか<br>以下すべてを満たす場合にtrueを返却する。<br>※DxAPIより片道検索で当該Air Boundのセグメントの数が1つである場合のみ空席待ちと返却されることを前提とするため、片道検索でセグメントの数が1つであるかの判定は不要とする。<br>   1. 当該Air Boundの第1セグメントがDxAPIより空席待ちと返却されている。   1. 当該Air Boundの出発日時が設定ファイルに定義された最終空席待ち期限を過ぎていない。   1. 当該Air Boundの第1セグメントの運航キャリアがNHグループ運航便または設定ファイルに定義された国内提携航空キャリアである。
   */
  isWaitlisted: boolean;
  /**
   * ASR席が全席無料で利用可能かどうか<br>DxAPIより、当該Fare FamilyにおいてASR席が全席無料で利用可能である場合にtrueを返却する。
   */
  isIncludedSeatAssignment: boolean;
  /**
   * 一人あたりの積算マイル数<br>   1. 当該Air Boundに含まれるNHグループ販売便のセグメント毎に、以下の通り積算マイル数を算出してその合算値を返却する。     1. 当該セグメントの積算マイル数は、基本マイル数とマイル積算率の積算値とする。<br>※基本マイル数はASWDB(マスタ)より、当該セグメントの出発・到着空港コードを基に取得する。<br>※マイル積算率はASWDB(マスタ)より、当該Air BoundのFare Basisを基に取得する。<br>※Fare Basisの一部桁数がワイルドカードのためワイルドカードに対応して取得する。<br>   1. 当該Air Boundに以下いずれかに該当するセグメントを含む場合は返却しない。     1. ASWDB(マスタ)より、当該セグメントの運航キャリアが積算マイル表示対象外である。     1. 基本マイル数、マイル積算率のいずれかが取得できない。
   */
  accrualMiles: number;
  /**
   * 障がい者運賃かどうか<br>当該Air BoundのTicket Designatorが設定ファイルに定義した障がい者割引運賃(Ticket designator)である場合にtrueを返却する。
   */
  isHandicappedFare: boolean;
  /**
   * 運賃種別<br>FareBasisの7桁目のコードが、運賃種別ごとに定義したプロパティの値と一致する場合、当該運賃種別の値を返却する。それ以外の場合は、「other：それ以外」を返却。
   */
  fareType: string;
}
export namespace RoundtripFppItemAirBoundsDataType {
  export type QuotaTypeEnum = 'enough' | 'available' | 'few' | 'soldOut';
  export const QuotaTypeEnum = {
    Enough: 'enough' as QuotaTypeEnum,
    Available: 'available' as QuotaTypeEnum,
    Few: 'few' as QuotaTypeEnum,
    SoldOut: 'soldOut' as QuotaTypeEnum,
  };
  export type UnavailableReasonEnum =
    | 'passedLastBookingDate'
    | 'incorrectChildFareCalculation'
    | 'unavailableJuniorPilot'
    | 'soldOut';
  export const UnavailableReasonEnum = {
    PassedLastBookingDate: 'passedLastBookingDate' as UnavailableReasonEnum,
    IncorrectChildFareCalculation: 'incorrectChildFareCalculation' as UnavailableReasonEnum,
    UnavailableJuniorPilot: 'unavailableJuniorPilot' as UnavailableReasonEnum,
    SoldOut: 'soldOut' as UnavailableReasonEnum,
  };
  export type CabinEnum = 'eco' | 'first';
  export const CabinEnum = {
    Eco: 'eco' as CabinEnum,
    First: 'first' as CabinEnum,
  };
  export type ChangeConditionsTypeEnum = 'unavailable' | 'withPenalty' | 'free';
  export const ChangeConditionsTypeEnum = {
    Unavailable: 'unavailable' as ChangeConditionsTypeEnum,
    WithPenalty: 'withPenalty' as ChangeConditionsTypeEnum,
    Free: 'free' as ChangeConditionsTypeEnum,
  };
  export type RefundConditionsTypeEnum = 'unavailable' | 'chargeable' | 'free';
  export const RefundConditionsTypeEnum = {
    Unavailable: 'unavailable' as RefundConditionsTypeEnum,
    Chargeable: 'chargeable' as RefundConditionsTypeEnum,
    Free: 'free' as RefundConditionsTypeEnum,
  };
}
